// Smooth-scroll helper shared by every CTA on the page.
// Uses the Lenis instance created in App.js when available, with a native
// fallback and a reduced-motion escape hatch.
export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (window.__lenis && !reduce) {
    window.__lenis.scrollTo(el, { offset: -16, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
  }
}
